import React, { Component } from 'react';

import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {  AddNannier, emailExist_check, communityEdit, communityReject, commonAPI  } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { MOBILE_REGEX, URL_REGEX } from '../../constant.js';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
const services = [{"id":1,"service":"Student Placement Counselling"},{"id":2,"service":"Learning Disability and Attention Deficit"},{"id":11,"service":"Higher Education Counselling"},{"id":12,"service":"Career Counselling"},{"id":13,"service":"Study Abroad Counselling"},{"id":14,"service":"Teen Counselling"},{"id":15,"service":"Child Counselling"},{"id":16,"service":"NA"}];
const Payments = [{"id":1,"payment_name":"Cash"},{"id":2,"payment_name":"Card"},{"id":3,"payment_name":"Cheque"},{"id":4,"payment_name":"Online Payments"},{"id":5,"payment_name":"NA"}];
const AgeGroup = [{"id":1,"name":"0 to 3 yrs"},{"id":2,"name":"4 to 8 yrs"}];
const timings = [{"id":3,"name":"Part Time"},{"id":4,"name":"Full Time"}];

const locations = [{"id":1,"location":"Bengaluru","latitude":"12.9716","longitude":"77.5946","status":1,"sort_order":1},{"id":12,"location":"Chennai","latitude":"13.0569","longitude":"80.2425","status":1,"sort_order":2},{"id":11,"location":"Coimbatore","latitude":"11.0168","longitude":"76.9558","status":1,"sort_order":3},{"id":2,"location":"Hyderabad","latitude":"17.3850","longitude":"78.4867","status":1,"sort_order":4},{"id":27,"location":"Hosur","latitude":"12.7409","longitude":"77.8253","status":1,"sort_order":4},{"id":24,"location":"Madurai","latitude":"9.9252","longitude":"78.1198","status":1,"sort_order":5},{"id":13,"location":"Mumbai","latitude":"19.0760","longitude":"72.8777","status":1,"sort_order":7},{"id":15,"location":"Kolkata","latitude":"22.5726","longitude":"88.3639","status":1,"sort_order":8},{"id":16,"location":"New Delhi","latitude":"28.6139","longitude":"77.2090","status":1,"sort_order":9},{"id":17,"location":"Jaipur","latitude":"26.9124","longitude":"75.7873","status":1,"sort_order":10},{"id":18,"location":"Chandigarh","latitude":"30.7333","longitude":"76.7794","status":1,"sort_order":11},{"id":19,"location":"Pune","latitude":"18.5204","longitude":"73.8567","status":1,"sort_order":12},{"id":20,"location":"Kochi","latitude":"9.9312","longitude":"76.2673","status":1,"sort_order":13},{"id":21,"location":"Noida","latitude":"28.5355","longitude":"77.3910","status":1,"sort_order":14},{"id":22,"location":"Agra","latitude":"27.1767","longitude":"78.0081","status":1,"sort_order":15},{"id":23,"location":"Puducherry","latitude":"11.9416","longitude":"79.8083","status":1,"sort_order":16},{"id":25,"location":"Tiruchirappalli","latitude":"10.7905","longitude":"78.7047","status":1,"sort_order":17},{"id":26,"location":"Indore","latitude":"22.719568","longitude":"75.857727","status":1,"sort_order":18}];


class verticalCommunityEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vendor_id: 1,
            pageid: '',
            category: 121,
            about: '',
            address: '',
            age_group: '',
            designation: '',
            service: '',
            email_id: '',
            errors: [],
            established_year: '',
            facebook: '',
            google_location: '',
            images: '',
            location: 'Bengaluru',
            mode_of_payment: '',
            name: '',
            phone_number: '',
            time: 3,
            twitter: '',
            website: '',
            mopList: Payments,
            ageGroup: AgeGroup,
            timeList: timings,
            getService: services,
            getId: this.props.match.params.id ? this.props.match.params.id : '',
            latitude: '',
            longitude: '',
            other_rating: '',
            categoryTypeList: [],
            subTypes: false,
            sub_category: '',
            attachment_file: [],
            attachment_file_length: 0,
            attachment_fileName: [],
            delete_array: [],
            edit_image: '',
            tempBanner: '',
            partner_type: '',
            preview: false,
            edited_data: [],
            keywordsArr: [],
            edited: false,
            location_list:locations
        }
        this.validator = new SimpleReactValidator({
            validators: {
                checkExist: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (val == '' && this.state.edit_image == '') {
                            return false;
                        }
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                emailExist_check: {  // name the rule
                    message: 'The :attribute Already Exist.',
                    rule: (val, params, validator) => {
                        return this.state.isEmailValid;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                checkMobile: MOBILE_REGEX,
                checkUrl: URL_REGEX
            }
        });
        this.getKeywords();
        //this.getpayment_type(); 
        //this.getNanniesList(); 
        //this.getService();
        this.loadFile = this.loadFile.bind(this)
    }
    componentDidMount() {
        if (this.state.getId) {
            this.getevent();
        }
        console.log(this.props.match.params.nadd)
        if (this.props.match.params.nadd == 122) {

            this.Cat_type();
        }
        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({
            login_id: vendor_id,
            role: auth_data.role,
        });
    }
    getKeywords = () => {
        commonAPI(JSON.stringify({ url: 'get_site_keywords', vertical:'community' })).then((res) => {
            if (res.status === 1) {
                this.setState({
                    keywordsArr: res.results
                })
            }
        })
    }
    validateMail = (value, catgry, vendr_id, pageid) => {
        let name = 'email_id';
        let type_name = 'isEmailValid';
        let req = JSON.stringify({
            [name]: value,
            category: catgry,
            vendor_id: vendr_id,
            pageid: pageid
        });
        let res = emailExist_check(req).then(res => {
            console.log('valuee', res);
            if (res.status === 1) {
                this.setState({
                    [type_name]: false
                });
            } else {
                // return res.status;
                this.setState({
                    [type_name]: true
                });
            }
        });
    }
    async getevent() {
        let response = await communityEdit(JSON.stringify({ id: this.state.getId }));
        // console.log(response);
        if (response.status == 1) {
            const data = response.data, edited_data = response.original;
            this.setState({
                pageid: data.id,
                designation: data.designation,
                service: (data.service!=null)? data.service.toString().split(','):[],
                name: data.name,
                address: data.address,
                email_id: data.email_id,
                phone_number: data.phone_no,
                website: data.website,
                location: data.location,
                google_location: data.google_location,
                facebook: data.fb,
                twitter: data.twitter,
                mode_of_payment: data.mop,
                established_year: data.established_year,
                time: data.time,
                about: data.about,
                images: data.images,
                photos: data.photos,
                other_rating: data.other_rating,
                longitude: data.longitude,
                latitude: data.latitude,
                sub_category: data.sub_category.toString().split(','),
                keywords: data.keywords ? data.keywords.split(';') : [],
                attachment_file: data.photo_arr,
                edit_image: data.images ? data.url + data.images : '',
                partner_type: data.partner_type,
                edited: data.edited,
                edited_data: edited_data
            });
            this.Geocode_location(data.google_location);
        }
    }
    async Cat_type() {
        let response = await FetchCall.getSubCategory(this.props.match.params.nadd);
        if (response.status == 1) {
            this.setState({ categoryTypeList: response.results, subTypes: true });
        } else {
            this.setState({ noCategory: false, subTypes: false });
        }
    }
    async getpayment_type() {
        let response = await FetchCall.getSchoolListDatas('payment_type');
        // console.log(response);
        if (response) {
            this.setState({ mopList: response.results });
        }
    }
    async getNanniesList() {
        let response = await FetchCall.getNanniesList('nannies');
        // console.log(response);
        if (response) {
            this.setState({ ageGroup: response.results, timeList: response.time });
        }
    }
    async getService() {
        let response = await FetchCall.getSchoolListDatas('services');
        // console.log(response);
        if (response) {
            this.setState({ getService: response.results });
        }
    }

    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh')
    }

    handleSelect = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);

        this.setState({ [propName]: value });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        this.clearValidationErr(e.target.name);
        if (e.target.name == 'google_location')
            this.Geocode_location();
        const propName = e.target.name;
        // if (propName == 'email_id') {
        //     this.validateMail(e.target.value, 121, this.state.vendor_id, this.state.pageid);
        // }
    };

    onSelect = (selectedList) => {
        let keywords = [];
        selectedList.map((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }
    onRemove = (selectedList, removedItem) => {
        let keywords = [];
        selectedList.map((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }


    handleFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let img = '';
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            img = reader.result;
            THIS.setState({
                tempBanner: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempBanner: ''
            });
        }
    };
    handleFileMultiple = (e) => {
        this.setState({ [e.target.name]: e.target.files });
    };

    showValidationErr(elm, msg) {
        this.setState((prevState) => ({ errors: [...prevState.errors, { elm, msg }] }));
    }
    clearValidationErr(elm) {
        this.setState((prevState) => {
            let newArr = [];
            for (let err of this.state.errors) {
                if (elm !== err.elm) {
                    newArr.push(err);
                }
            }
            return { errors: newArr };
        })
    }

    Geocode_location(location = '') {
        Geocode.fromAddress(location ? location : this.state.google_location).then(
            response => {
                const { lat, lng } = response.results[0].geometry.location;
                if (lat && lng)
                    this.get_location(lat, lng);
            },
            error => {
                console.error(error);
            }
        );

    }

    get_location(lat, lng) {
        this.setState({
            latitude: lat,
            longitude: lng
        });
    }

    removeImage = e => {
        var delete_array = this.state.delete_array;
        delete_array.push(e)
        const updated = this.state.attachment_file.filter(item => item.name !== e)
        this.setState({
            attachment_file: updated,
            delete_array: delete_array,
        })
    }

    remove_img() {
        jQuery('#edit_image').remove();
    }

    loadFile(e) {
        var files = e.target.files
        this.setState({ attachment_file_length: files.length })
        if (files.length > 0) {
            jQuery('.upload-space').addClass('hide')
            jQuery('.upload-thumb').removeClass('hide')
            var fileArra = this.state.attachment_file

            //console.log('fileArra',fileArra)
            //var fileThumbArra = this.state.imgThumb;
            for (var i = 0; i < files.length; i++) {
                fileArra.push(e.target.files[i])
                this.setState({
                    selectedFile: URL.createObjectURL(e.target.files[i]),
                    attachment_file: fileArra
                })
            }
            this.clearValidationErr('attachment_file');
        }
    }
    handlePreview = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                preview: true
            })
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        const { edited_data, edited } = this.state;
        this.validator.purgeFields();

        return (  
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Community Info Management</h4>
                                   
                    <div className="row">
                        <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                          <div className="">
                              <div id="company-info" className="tab-pane active">
                                    <form onSubmit={this.handlePreview} className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                        <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Partner Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.partner_type}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="partner_type"
                                                                    title='Select'>
                                                                    <option value='1'>Institution</option>
                                                                    <option value='2'>Individuals</option>
                                                                </select>
                                                                {this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.name != this.state.name) && 'edited-field'}>
                                                                Counselor Center<span className="astrick">*</span></label>
                                                            <input type="text" name="name"
                                                                value={this.state.name}
                                                                placeholder="Name"
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Counselor Center', this.state.name, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.designation != this.state.designation) && 'edited-field'}>
                                                                Designation<span className="astrick">*</span></label>
                                                            <input type="text" name="designation"
                                                                value={this.state.designation}
                                                                placeholder="Your role"
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Designation', this.state.designation, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.service != this.state.service) && 'edited-field'}>
                                                                Service<span className="astrick">*</span></label>
                                                            <div className='custom-select-drop dropdown'>

                                                                <select
                                                                    multiple
                                                                    value={this.state.service}
                                                                    name="service"
                                                                    id="service"
                                                                    onChange={this.handleSelect}
                                                                    className="form-control selectpicker"
                                                                    title='Select'
                                                                >
                                                                    {this.state.getService.length > 0 &&
                                                                        this.state.getService.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.service}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Service', this.state.service, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Information</span>
                                                        </div>                                                                                                                <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.address != this.state.address) && 'edited-field'}>
                                                                Address<span className="astrick">*</span></label>
                                                            <input type="text" name="address" value={this.state.address}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.email_id != this.state.email_id) && 'edited-field'}>
                                                                Email Id<span className="astrick">*</span></label>
                                                            <input type="text" name="email_id"
                                                                value={this.state.email_id}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Email Id', this.state.email_id, 'required|email', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.phone_no != this.state.phone_number) && 'edited-field'}>
                                                                Phone No <span className="astrick">*</span></label>
                                                            <input
                                                                type='text'
                                                                name="phone_number"
                                                                value={this.state.phone_number}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.website != this.state.website) && 'edited-field'}>
                                                                Website <span className="astrick">*</span></label>
                                                            <input name="website"
                                                                value={this.state.website}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.location != this.state.location) && 'edited-field'}>
                                                                Location<span className="astrick">*</span></label>

                                                                <select
                                name="location"
                                id="location"
                                onChange={this.handleSelect}
                                value={this.state.location}
                                className="form-control selectpicker"
                              >
                                {this.state.location_list.length > 0 &&
                                  this.state.location_list.map((item, i) => {
                                    return (
                                      <option value={item.location} >
                                        {item.location}
                                      </option>
                                    )
                                  })}
                              </select>

                                                            
                                                            {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.google_location != this.state.google_location) && 'edited-field'}>
                                                                Google location Address<span className="astrick">*</span></label>
                                                            <input type="text" name="google_location"
                                                                value={this.state.google_location}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Google location', this.state.google_location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.latitude != this.state.latitude) && 'edited-field'}>
                                                                Latitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="latitude"
                                                                value={this.state.latitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.longitude != this.state.longitude) && 'edited-field'}>
                                                                Longitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="longitude"
                                                                value={this.state.longitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.other_rating != this.state.other_rating) && 'edited-field'}>
                                                                Google Rating
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step='0.01'
                                                                name="other_rating"
                                                                value={this.state.other_rating}
                                                                onChange={this.handleChange}
                                                                max='5'
                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.fb != this.state.facebook) && 'edited-field'}>
                                                                Facebook<span className="astrick">*</span></label>
                                                            <input type="text" name="facebook"
                                                                value={this.state.facebook}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.twitter != this.state.twitter) && 'edited-field'}>
                                                                Twitter<span className="astrick">*</span></label>
                                                            <input type="text" name="twitter"
                                                                value={this.state.twitter}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.mop != this.state.mode_of_payment) && 'edited-field'}>
                                                                Mode of Payment<span className="astrick">*</span></label>
                                                            <div className='custom-select-drop dropdown'>
                                                                <select
                                                                    value={this.state.mode_of_payment}
                                                                    name="mode_of_payment"
                                                                    id="mode_of_payment"
                                                                    onChange={this.handleSelect}
                                                                    multiple="multiple"
                                                                    className="form-control selectpicker" title='Select'
                                                                >
                                                                    {this.state.mopList.length > 0 &&
                                                                        this.state.mopList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.payment_name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Mode of Payment', this.state.mode_of_payment, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.established_year != this.state.established_year) && 'edited-field'}>
                                                                Established Year <span className="astrick">*</span></label>
                                                            <input type="text" name="established_year"
                                                                value={this.state.established_year}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Established Year', this.state.established_year, '', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Established Year', this.state.established_year, 'required|numeric|min:4|max:4', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.about != this.state.about) && 'edited-field'}>
                                                                About<span className="astrick">*</span></label>
                                                            <textarea type="text" value={this.state.about} name="about"
                                                                onChange={this.handleChange} className="form-control" ></textarea>
                                                            {this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.keywords != this.state.keywords) && 'edited-field'}>
                                                                Keywords<span className="astrick">*</span></label>
                                                            <Multiselect
                                                                isObject={false}
                                                                options={this.state.keywordsArr} // Options to display in the dropdown
                                                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                                                onSelect={this.onSelect} // Function will trigger on select event
                                                                onRemove={this.onRemove} // Function will trigger on remove event
                                                            />
                                                            {/* <textarea
                                                                name="keywords"
                                                                value={this.state.keywords}
                                                                onChange={this.handleChange}
                                                                className="form-control"
                                                                placeholder="ex: school,category names,location name,etc"
                                                            ></textarea> */}
                                                            {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.images != this.state.images) && 'edited-field'}>
                                                                Banner Image <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="images"
                                                                onChange={this.handleFile}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        {(this.state.edit_image != '' || this.state.tempBanner != '') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                                                    <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Img" class="img-thumbnail" />

                                                                </div>
                                                            )
                                                        }

                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label
                                                                className={edited && (edited_data.photos != this.state.photos) && 'edited-field'}>
                                                                Gallery Images <span className="astrick">*</span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-12 float-left mt-4 p-0">

                                                            <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                                                <div className='upload-wizard'>
                                                                    <div className='upload-thumb'>
                                                                        <ul className='list-inline'>
                                                                            {this.state.attachment_file.map((file_data, index) => {


                                                                                var file_url;
                                                                                if (file_data.name) {
                                                                                    let url = file_data.image_thumb ? file_data.image_thumb : '';
                                                                                    if (url != '') {
                                                                                        file_url = file_data.image_thumb;
                                                                                    } else {
                                                                                        file_url = URL.createObjectURL(file_data);
                                                                                    }
                                                                                    // var file_url = URL.createObjectURL(file_data)
                                                                                    // var file_name = file_data.name
                                                                                    if (file_data.type === 'application/pdf') {
                                                                                        var blob = file_url
                                                                                        //console.log('blob_url', file_data.name)
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_name}</span> */}
                                                                                                <a href='javascript:;' className='del-btn' onClick={() => {
                                                                                                    this.removeImage(file_data.name)
                                                                                                }}>
                                                                                                    <img
                                                                                                        src={'../../../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                                                                <a
                                                                                                    href='javascript:;'
                                                                                                    className='del-btn'
                                                                                                    onClick={() => {
                                                                                                        this.removeImage(file_data.name)
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={'../../../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            })}
                                                                            <li className='addMore'>
                                                                                <input
                                                                                    type='file'
                                                                                    name='imgInp[]'
                                                                                    id='imgInp2'
                                                                                    className='add_img'
                                                                                    multiple
                                                                                    onChange={this.loadFile.bind(this)}
                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                />
                                                                                <a href='javascript:;' className='add-more'>
                                                                                    <div>
                                                                                        <img src={'../../../assets/images/upload-icon.svg'} alt='icon' />
                                                                                        Add more
                                                                                    </div>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <div className="col-md-12 col-xs-12 btn-bdr">
                                                <button id="btnSubmit" className="btn btn-primary btn-sm">Preview</button>
                                            </div>
                                    </form>
                            </div>
                          </div>
                        </div>
                    </div>  


                </div>
              </div>
            </div>

            {this.preview()}
            <NotificationContainer/>                                                                            
            </AdminLayout>
               
      </React.Fragment >
    );
  }
  
preview = () => {
        return (
            <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
                <ModalBody className='p-0'>
                    <Row>
                        <Col md='12'>
                            <img src='/assets/images/user-header.png' className='preview-header' />
                        </Col>
                    </Row>
                    <Row className='pv-banner'>
                        <Col className='pv-banner-bg' md='12'>
                            <div className='title-section'>
                                <p className="banner-title">{this.state.name}</p>
                                <p className="banner-address">{this.state.address}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>About the School</h4>
                                <p className="">{this.state.about_school}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Key Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Email Id</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.email_id}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Mode of Payment</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {this.state.mopList.map((item) => {
                                                    if (item.id == this.state.mode_of_payment) {
                                                        return (
                                                            item.payment_name
                                                        )
                                                    }
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Establishment Year</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.established_year}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Avg Fee</b></div>
                                        <div className='key-po'>
                                            <p>{parseFloat(this.state.avg_anual_fee) > 0 ? `${this.state.avg_anual_fee}/Month` : 'NA'}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Facebook</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.facebook}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Twitter</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.twitter}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Phone No</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.phone_number}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Gallery</h4>
                                <div className='row'>
                                    {this.state.attachment_file.map((item) => {
                                        console.log('********', item);
                                        if (item.image_thumb) {
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={item.image_thumb} className='preview-image' />
                                                </div>
                                            )
                                        } else if (item.name) {
                                            let file_url = URL.createObjectURL(item);
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={file_url} className='preview-image' />
                                                </div>
                                            )
                                        }
                                    })}
                                    {this.state.attachment_file.length === 0 && (
                                        <div className='col-md-4'>No Gallery Images Found</div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Contact Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        Email Id : {this.state.email_id}
                                    </div>
                                    <div className='col-md-4'>
                                        Contact : {this.state.phone_number}
                                    </div>
                                    <div className='col-md-4'>
                                        Website : {this.state.website}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                                {this.state.edited && this.state.role == 1 ? 'Approve' : 'Submit'}
                            </button>
                            {this.state.edited && this.state.role == 1 && (
                                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                                    onClick={this.handleReject}>
                                    Reject
                                </button>
                            )}
                            <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                                onClick={() => { this.setState({ preview: false }) }}>Close</button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal >
        )
    }
    handleReject = (e) => {
        e.preventDefault();
        let req = JSON.stringify({
            id: this.state.getId
        })
        let toastr = '';
        communityReject(req).then((res => {
            if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('success', {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
                window.location.href = document.referrer;
            }
        }))
    }
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            let subData = {
                login_id: this.state.login_id,
                designation: this.state.designation,
                service: this.state.service,
                name: this.state.name,
                age_grp: this.state.age_group,
                address: this.state.address,
                email_id: this.state.email_id,
                phone_no: this.state.phone_number,
                website: this.state.website,
                location: this.state.location,
                google_location: this.state.google_location,
                fb: this.state.facebook,
                twitter: this.state.twitter,
                mop: this.state.mode_of_payment,
                established_year: this.state.established_year,
                time: this.state.time,
                about: this.state.about,
                images: this.state.images,
                category: this.state.category,
                getId: this.state.getId,
                photos: this.state.attachment_file,
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                other_rating: this.state.other_rating,
                sub_category: 122,
                keywords: this.state.keywords ? this.state.keywords.join(';') : '',
                delete_array: this.state.delete_array,
                partner_type: this.state.partner_type,
                role: this.state.role
            }
            // jQuery("#btnSubmit").attr('disabled', true);
            AddNannier(subData).then((res) => {
              
                if (res.status === 1) {
                    
                    NotificationManager.success(res.message);
                    window.location.href = document.referrer;

                } else {
                    jQuery("#btnSubmit").attr('disabled', false);
                    
                    NotificationManager.error('Something went wrong. try again!...');
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

}

export default verticalCommunityEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalCommunityEdit.jsx